import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';

import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import IconButton from '@mui/material/IconButton';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import { useDeadline } from "../../../contexts/DeadlineContext";
const EmailSettings = () => {
    const history = useHistory();
    const domainUrl = window.location.origin;
    const eventid = localStorage.getItem('eventid');
    const [comapanyHeader, setCompanyHeader] = useState("");
    const [comapanyFooter, setCompanyFooter] = useState("");
    const { offButton, abstractHomeSetup, getAbstractDeadLineStatus } = useDeadline();
    const [settings, setSettings] = useState({
        MAIL_PROTOCOL: '',
        MAIL_HOST: '',
        MAIL_USERNAME: '',
        MAIL_PASSWORD: '',
        MAIL_CRYPTO: '',
        MAIL_PORT: '',
        MAIL_FROM: '',
        APPLICATION_URL: domainUrl || '',
        ENABLED_MAIL: "",
    });

    useEffect(() => {
        const eventid = localStorage.getItem('eventid');

        axios.get(`/api/get-setting/${eventid}`)
            .then(response => {
                const settingsData = response.data.settings;
                setSettings(settingsData);
            })
            .catch(error => {
                console.error('Error fetching email settings:', error);
            });
    }, []);



    const handleChange = (event) => {
        const { name, value } = event.target;
        setSettings(prevSettings => ({
            ...prevSettings,
            [name]: value
        }));
    };

    console.log("comapanyFooter", comapanyFooter)
    // const StoreSmtpSetting = (e) => {
    //     e.preventDefault();

    //     //const test = 123;
    //     const data = {

    //         eventid,
    //         settings,
    //         comapanyHeader,
    //         comapanyFooter,

    //     };
    //     console.log(data);
    //     axios.get('/sanctum/csrf-cookie').then(response => {
    //         const config = {
    //             headers: { 'content-type': 'multipart/form-data' }
    //         }
    //         axios.post(`/api/configuration-setting`, data,).then(res => {
    //             if (res.data.status === 200) {
    //                 swal('Success', res.data.message, 'success');

    //                 history.push('/admin/email/setting');
    //             }
    //             // else {
    //             //     setAddSmtpSetting({ ...addSmtpSetting, error_list: res.data.validate_error })
    //             // }
    //         });
    //     });


    // }

    const StoreSmtpSetting = (e) => {
        e.preventDefault();

        const formData = new FormData();

        formData.append('eventid', eventid);

        // Append each setting manually to FormData
        Object.entries(settings).forEach(([key, value]) => {
            formData.append(`settings[${key}]`, value);
        });

        // Append images if selected
        if (comapanyHeader instanceof File) {
            formData.append('comapanyHeader', comapanyHeader);
        }

        if (comapanyFooter instanceof File) {
            formData.append('comapanyFooter', comapanyFooter);
        }

        axios.get('/sanctum/csrf-cookie').then(() => {
            axios.post(`/api/configuration-setting`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                if (res.data.status === 200) {
                    axios.get(`/api/get-setting/${eventid}`)
                        .then(response => {
                            const settingsData = response.data.settings;
                            setSettings(settingsData);
                        })
                        .catch(error => {
                            console.error('Error fetching email settings:', error);
                        });
                    swal('Success', res.data.message, 'success');
                    history.push('/admin/email/setting');
                } else {
                    swal('Error', 'Something went wrong', 'error');
                }
            });
        });
    };




    let backGroundButtonByEvent = "";
    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }


    return (
        <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
            <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
                <h4 sx={{ m: 2, color: '#000000' }} >
                    <Button sx={{
                        float: 'right',
                        backgroundColor: backGroundButtonByEvent,
                        marginTop: '2%',
                        ":hover": {
                            color: "white"
                        }
                    }}
                        color='success'
                        size='small'
                        variant='contained'

                        onClick={() => history.goBack()}>
                        Back
                    </Button>
                    <Button sx={{ marginRight: '2%',marginTop: '2%', backgroundColor: backGroundButtonByEvent, float: 'right', ":hover": { color: "white" } }}
                        color='success'
                        size='small'
                        variant='contained'
                        component={Link}
                        to="/admin/test/email"  >
                        Test  Email
                    </Button>
                </h4>
                <Card sx={{ width: '60vw', float: 'center' }} >
                    <CardContent >
                        <Typography component="h1" variant="h5">
                            Email Settings

                            {/* <Button sx={{ float: 'right', backgroundColor: backGroundButtonByEvent, ":hover": { color: "white" } }}
                                color='success'
                                size='small'
                                variant='contained'
                                component={Link}
                                to="/admin/general/setting">
                                Genral Setting
                            </Button> */}
                            {/* <Button sx={{ marginRight: '2%', backgroundColor: backGroundButtonByEvent, float: 'right', ":hover": { color: "white" } }}
                                color='success'
                                size='small'
                                variant='contained'
                                component={Link}
                                to="/admin/test/email"  >
                                Test  Email
                            </Button> */}


                        </Typography>
                        <Box component="form" onSubmit={StoreSmtpSetting} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={4}>


                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="MAIL PROTOCOL"
                                        autoFocus
                                        name='MAIL_PROTOCOL'
                                        value={settings.MAIL_PROTOCOL || ""}
                                        onChange={handleChange} />
                                </Grid>

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="MAIL HOST"
                                        autoFocus
                                        placeholder="smtp.gmail.com"
                                        name='MAIL_HOST'
                                        value={settings.MAIL_HOST || ""}
                                        onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="MAIL USERNAME"
                                        placeholder="abc@gmail.com"
                                        autoFocus
                                        name='MAIL_USERNAME'
                                        value={settings.MAIL_USERNAME || ""}
                                        onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        required
                                        fullWidth
                                        label="MAIL PASSWORD"
                                        //type="password"
                                        id="password"
                                        autoComplete="new-password"
                                        name='MAIL_PASSWORD'
                                        value={settings.MAIL_PASSWORD || ""}
                                        onChange={handleChange} />
                                </Grid>

                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="MAIL CRYPTO"
                                        autoFocus
                                        placeholder="TLS"
                                        name='MAIL_CRYPTO'
                                        value={settings.MAIL_CRYPTO || ""}
                                        onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="MAIL PORT"
                                        autoFocus
                                        placeholder="587"
                                        name='MAIL_PORT'
                                        value={settings.MAIL_PORT || ""}
                                        onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="MAIL FROM"
                                        autoFocus
                                        placeholder="abc@gmail.com"
                                        name='MAIL_FROM'
                                        value={settings.MAIL_FROM || ""}
                                        onChange={handleChange} />
                                </Grid>
                                <Grid item xs={6} >
                                    <TextField
                                        autoComplete="given-name"
                                        required
                                        fullWidth
                                        label="APPLICATION_URL"
                                        autoFocus
                                        name='APPLICATION_URL'
                                        value={settings.APPLICATION_URL || ""}
                                        onChange={handleChange} />
                                </Grid>
                                <Grid item xs={12} >

                                    <FormControl fullWidth>
                                        <InputLabel id="mail-protocol-label">ENABLED MAIL</InputLabel>
                                        <Select
                                            labelId="mail-protocol-label"
                                            id="mail-protocol"
                                            label="ENABLED MAIL"
                                            name="ENABLED_MAIL" // Ensure this matches the property name in your state
                                            value={settings.ENABLED_MAIL | ""}
                                            onChange={handleChange}>
                                            <MenuItem value={1}>Active</MenuItem>
                                            <MenuItem value={0}>InActive</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6} >
                                    <span>Company Header</span>
                                    <label htmlFor="icon-button-file">
                                        <TextField accept="image/*" id="icon-button-file" type="file" onChange={(e) => setCompanyHeader(e.target.files[0])} />
                                        <IconButton color="primary" aria-label="upload picture" component="span">
                                            <PhotoCamera />
                                        </IconButton><br /><br />
                                        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                            Recommended image size: 1280px (width) × 552 (height)
                                            <br />
                                            Extention: jepg
                                        </Typography>

                                        {
                                            !settings.COMPANY_HEADER ?
                                                <span>No Header Uploaded</span> :
                                                <><img src={settings.COMPANY_HEADER} width="350" height="150" />
                                                </>
                                        }
                                    </label>

                                </Grid>
                                <Grid item xs={6} >
                                    <span>Company Footer</span>
                                    <label htmlFor="icon-button-file">
                                        <TextField accept="image/*" id="icon-button-file" type="file" onChange={(e) => setCompanyFooter(e.target.files[0])} />
                                        <IconButton color="primary" aria-label="upload picture" component="span">
                                            <PhotoCamera />
                                        </IconButton><br /><br />
                                        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                                            Recommended image size: 1280px (width) × 552 (height)
                                            <br />
                                            Extention: jepg
                                        </Typography>

                                        {
                                            !settings.COMPANY_FOOTER ?
                                                <span>No Footer Uploaded</span> :
                                                <><img src={settings.COMPANY_FOOTER} width="350" height="150" />
                                                </>
                                        }
                                    </label>

                                </Grid>
                            </Grid>
                            <Grid container justifyContent="flex-end">
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 5, backgroundColor: backGroundButtonByEvent, }} >
                                    Submit
                                </Button>
                            </Grid>
                        </Box>
                    </CardContent>
                </Card >
            </Box >
        </div >

    );
}

export default EmailSettings;
